import type * as React from "react";

import { Trans, useTranslation } from "react-i18next";

export const LinkExpires: React.FC<{ expiryDate: string; boldComponent?: React.JSX.Element }> = ({ expiryDate, boldComponent }) => {
    const { t } = useTranslation();

    return (
        <Trans
            t={t}
            i18nKey="Link expires on: <0>{{expiryDate}}</0>"
            components={[boldComponent ?? <strong key="expirydate"/>]}
            values={{ expiryDate }}
        />
    );
};

LinkExpires.displayName = 'LinkExpires';